import React from "react";

interface AudioViewProps {
  state: "waiting" | "recording";
  micLevel: number;
  secondsLeft: number;
}

/** Microphone panel shown during the audio checks; pulses with the input level */
const AudioView: React.FC<AudioViewProps> = ({ state, micLevel, secondsLeft }) => (
  <div className="rounded-xl bg-primary/10 w-[250px] h-[250px] max-w-full mx-auto flex flex-col items-center justify-center gap-4">
    <div
      className={`w-24 h-24 rounded-full bg-primary text-white flex items-center justify-center transition-transform duration-75 ${state === "recording" ? "ring-8 ring-primary/20" : ""}`}
      style={{ transform: `scale(${1 + Math.min(0.3, micLevel * 2)})` }}
    >
      <svg className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
        />
      </svg>
    </div>
    {state === "recording" ? (
      <p className="flex items-center gap-2 text-sm font-medium text-gray-700">
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse" />
        Recording — speak now
        <span className="font-mono">00:{secondsLeft.toString().padStart(2, "0")}</span>
      </p>
    ) : (
      <p className="text-sm text-gray-600">Waiting for microphone…</p>
    )}
  </div>
);

export default AudioView;
